import CSS from './SearchButton.module.css';
import { useTranslation } from '@CS/hooks';
import content from './content';

type SearchButtonProps = {
  onClick: () => void;
};

export default function SearchButton({ onClick }: SearchButtonProps) {
  const button = useTranslation(content.button);

  return (
    <button className={CSS.button} onClick={onClick}>
      {button}
    </button>
  );
}
